/**
 * 浏览器通知
 *
 * @param {string} tag
 * @param {string} title
 * @param {string} body
 * @param {string} icon
 * @returns
 */
export const notification = (tag, title, body = "", icon = "") => {
	if (!("Notification" in window)) {
		console.warn("This browser does not support desktop notification");
		return;
	}

	if (Notification.permission === "granted") {
		const notification = new Notification(title, {
			dir: "auto",
			lang: "zh",
			tag: tag,
			body: body,
			icon: icon,
			requireInteraction: true
		});

		console.log(notification);

		return notification;
	}

	if (Notification.permission !== "denied") {
		Notification.requestPermission(permission => {
			if (permission === "granted") {
				const notification = new Notification(title, {
					dir: "auto",
					lang: "zh",
					tag: tag,
					body: body,
					icon: icon,
					requireInteraction: true
				});

				return notification;
			}
		});
	}
};
